// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

// Local Imports
import endPoints from '../../constant';
import axiosInstance from '../../http';

export interface InitialStateProps {
  allUsers?: any;
  loading?: boolean;
  error?: string | null;
}
interface UsersAPIParams {
  search?: string | null;
  type?: string | null;
}

const initialState: InitialStateProps = {
  allUsers: [],
  loading: false,
  error: null,
};

// All Users API Calling
export const allUsersAPI = createAsyncThunk(
  'dashboard/users',
  async (params: UsersAPIParams, { rejectWithValue }) => {
    try {
      console.log('params', params);
      const { search, type } = params;
      let endPoint = endPoints.usersListing;
      // Search User Query
      if (search) {
        endPoint = `${endPoints.usersListing}/?search=${search}`;
      }
      // Filter User Query
      if (type) {
        endPoint = `${endPoints.usersListing}/?type=${type}`;
      }
      const { data } = await axiosInstance.get(endPoint);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Users Slice
export const userSlice = createSlice({
  name: 'dashboard/users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(allUsersAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allUsersAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
        state.error = null;
      })
      .addCase(allUsersAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(PURGE, (state) => {
        state.allUsers = [];
      });
  },
});

// Action creators are generated for each case reducer function
// export const {  } = userSlice.actions;

export default userSlice.reducer;
